<mat-card appearance="outlined" class="bg-{{ color }}-50 border-{{ color }} rounded-md">
    <mat-card-content class="flex flex-row gap-2 items-center text-dark-800">
        <myrtls-icon class="text-{{ color }}" [icon]="icon"></myrtls-icon>
        <div class="font-light">
            <ng-content />
        </div>
    </mat-card-content>
</mat-card>
